import styled from 'styled-components'

export const StyledButtonIcon = styled.button(({ theme }) => ({
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },

  alignItems: 'center',
  aspectRatio: '1/1',
  background: 'transparent',
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['16'],
  color: theme.colors.black800,
  cursor: 'pointer',
  display: 'flex',
  flexShrink: 0,
  fontSize: '1.6rem',
  fontWeight: 600,
  height: '100%',
  justifyContent: 'center',
  textAlign: 'center',
}))
